module.exports = __webpack_public_path__ + "img/21.7d577f6b.jpg";